import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const VortexShatterAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const count = 30;
  const rot = progress * Math.PI * 15;
  for (let i = 0; i < count; i++) {
    const baseAng = (i / count) * Math.PI * 2;
    const a = baseAng + rot;
    const d = e.maxRadius + progress * 200;
    const r = getRadiusAtAngle(a, e, d);
    ctx.beginPath(); ctx.arc(e.pos.x + Math.cos(a) * r, e.pos.y + Math.sin(a) * r, 6, 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('VORTEX_SHATTER', VortexShatterAnimation);
